import { render, staticRenderFns } from "./helpCentre.vue?vue&type=template&id=ed947db8&scoped=true&"
import script from "./helpCentre.vue?vue&type=script&lang=js&"
export * from "./helpCentre.vue?vue&type=script&lang=js&"
import style0 from "./helpCentre.vue?vue&type=style&index=0&id=ed947db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed947db8",
  null
  
)

export default component.exports